import * as React from "react";
import { useMemo } from "react";
import { useUser } from "../user/useUser";
import { hrefToDashes } from "../utils";
import { useMenu } from "./useMenu";

export const FreeTrialAndLogin = () => {
  const { loggedIn, premium, user, hasSubscription } = useUser();
  const { freeTrial, login, becomeMemberPayment } = useMenu().items;

  const shouldComponentRender = useMemo(
    () => !loggedIn || !premium || !hasSubscription || user,
    [loggedIn, premium, hasSubscription, user]
  );

  if (!shouldComponentRender) return null;

  let label = freeTrial.label;
  let href = freeTrial.href;
  if (loggedIn && !hasSubscription) {
    label = becomeMemberPayment.label;
    href = becomeMemberPayment.href;
  }

  return (
    <div className="elm-my-3">
      <ul className="elm-mx-0 elm-p-0 elm-my-2 elm-flex elm-list-none" role="group">
        {(!premium || !hasSubscription) && (
          <li className="hide_in_app elm-text-center elm-rounded-full elm-bg-dd-green-900 elm-transition elm-flex-grow-0 elm-w-1/2 elm-mr-1.5 lg:hover:elm-bg-dd-green-800">
            <a
              tabIndex={0}
              title={label}
              aria-label={label}
              data-track-label={hrefToDashes(href)}
              href={href}
              className="focus:elm-outline-none elm-text-base elm-transition elm-cursor-pointer elm-pointer-events-auto elm-no-underline elm-py-3 elm-block elm-text-white lg:hover:elm-text-white"
            >
              {label}
            </a>
          </li>
        )}
        {!loggedIn && (
          <li className="elm-text-center elm-rounded-full elm-bg-dd-blue-900 elm-transition elm-flex-grow-0 elm-w-1/2 elm-ml-1.5 lg:hover:elm-bg-dd-blue-800">
            <a
              title={login.label}
              aria-label={login.label}
              tabIndex={0}
              data-track-label={hrefToDashes(login.href)}
              href={login.href}
              className="focus:elm-outline-none elm-text-base elm-transition elm-cursor-pointer elm-pointer-events-auto elm-no-underline elm-py-3 elm-block elm-text-white lg:hover:elm-text-white"
            >
              {login.label}
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};
